// @core/api/endpoints/task/create_task_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTaskNumberingSchemeRequest,
  TaskNumberingSchemeResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create numbering scheme
 * Creates a task numbering scheme (e.g., MP-123, BACK-42). Defines prefix, pattern, and scope for auto-numbering.
 */
export async function CreateTaskNumberingScheme(
  data: CreateTaskNumberingSchemeRequest,
  options?: RequestOptions
): Promise<TaskNumberingSchemeResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-numbering-schemes`;
  const requestOptions = options;
  return client.post<TaskNumberingSchemeResponse>(requestPath, data, requestOptions);
}
